import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
// Styles
import styles from './icon.module.scss'

Icon.propTypes = {
    /** Icon object that contains name and path and other attributs to create the icon. */
    icon: PropTypes.object.isRequired,
    /** Sets viebox dimensions of the svg icon */
    viewBoxDim: PropTypes.number,
}

Icon.defaultProps = {
    viewBoxDim: 1024,
}

/**
 * Find and create svg path for the given icon name.
 * @param name
 * @returns {HTMLElement<typeof path>}
 * @constructor
 */
function SvgPath({ iconObj }) {
    if (!iconObj) {
        return null
    }

    return iconObj.icon.paths.map((path, index) => {
        // Get any custom attributes
        const attrs = iconObj.icon?.attrs

        return <path key={index} {...attrs[index]} d={path} />
    })
}

function Icon({ icon, viewBoxDim }) {
    return (
        <svg
            viewBox={`0 0 ${viewBoxDim} ${viewBoxDim}`}
            className={cx('icon', styles.icon)}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            role="img"
        >
            <SvgPath iconObj={icon} />
        </svg>
    )
}

export default Icon
